export default __webpack_public_path__ + "static/13-c5758699519d2ada1ee2c58087751522.jpg";